import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompiledReportsModel } from 'common/models/page-models/reports/compiled-reports/compiled-data-model';
import { CompiledReportsListingModel } from 'common/models/page-models/reports/compiled-reports/compiled-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CompiledReportsWidgetService } from 'common/widget/reports/compiled-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class CompiledReportsResolver extends GridResolver<CompiledReportsModel, CompiledReportsListingModel> {
    constructor(
        protected fs: CompiledReportsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new CompiledReportsModel();
        return dataModel;
    }
}